var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"show":_vm.customModal.show},on:{"close":_vm.hideCustomModal}},[_c(_vm.customModal.component,_vm._g(_vm._b({tag:"component",on:{"close":_vm.hideCustomModal}},'component',_vm.customModal.attrs,false),_vm.customModal.listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }